"use strict";
/** @module models */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCUAlertAction = exports.SCUAlert = void 0;
var cerealParse_1 = require("../cerealParse");
var uuid = require("uuid");
var bryxTypes_1 = require("./bryxTypes");
/**
 * Class representing a SCU alert and providing a static parse method.
 */
var SCUAlert = /** @class */ (function () {
    function SCUAlert(id, name, actions) {
        this.id = id;
        this.name = name;
        this.actions = actions;
    }
    /**
     * Parse object potentially representing a SCUAlert.
     * @param o
     * @return Parse result
     */
    SCUAlert.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUAlert(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'actions', SCUAlertAction.parse, 'warn')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUAlert Model: ".concat(e.message));
        }
    };
    /**
     * Create new, identical instace of SCUAlert.
     * @return New, identical SCUAlert instance.
     */
    SCUAlert.prototype.copy = function () {
        return new SCUAlert(this.id, this.name, this.actions);
    };
    return SCUAlert;
}());
exports.SCUAlert = SCUAlert;
/**
 * Class representing a SCU alert action and providing a static parse method.
 */
var SCUAlertAction = /** @class */ (function () {
    function SCUAlertAction(id, message, content) {
        this.id = id;
        this.message = message;
        this.content = content;
    }
    /**
     * Parse object potentially representing a SCUAlertAction.
     * @param o
     * @return Parse result
     */
    SCUAlertAction.parse = function (o) {
        try {
            var content = void 0;
            var contentType = cerealParse_1.ParseUtils.getString(o, 'type');
            switch (contentType) {
                case 'phone':
                    content = { type: 'phone', number: cerealParse_1.ParseUtils.getString(o, 'number') };
                    break;
                case 'email':
                    content = { type: 'email', email: cerealParse_1.ParseUtils.getString(o, 'email') };
                    break;
                case 'sms':
                    content = { type: 'sms', number: cerealParse_1.ParseUtils.getString(o, 'number') };
                    break;
                case 'webhook':
                    content = {
                        type: 'webhook',
                        url: cerealParse_1.ParseUtils.getString(o, 'url'), method: cerealParse_1.ParseUtils.getEnum(o, 'method', bryxTypes_1.WebhookHTTPMethod),
                    };
                    break;
                default:
                    return cerealParse_1.ParseUtils.parseFailure("Invalid SCUAlertAction Model: Invalid type ".concat(contentType));
            }
            return cerealParse_1.ParseUtils.parseSuccess(new SCUAlertAction(uuid.v4(), cerealParse_1.ParseUtils.getStringOrNull(o, 'message'), content));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUAlertAction Model: ".concat(e.message));
        }
    };
    /**
     * Get empty SCUAlertActionTemplate instance.
     * @param type
     * @return SCUAlertActionTemplate
     */
    SCUAlertAction.getEmptyTemplate = function (type) {
        var content;
        switch (type) {
            case 'email':
                content = { type: 'email', email: null };
                break;
            case 'phone':
                content = { type: 'phone', number: null };
                break;
            case 'sms':
                content = { type: 'sms', number: null };
                break;
            case 'webhook':
            default:
                content = { type: 'webhook', url: null, method: bryxTypes_1.WebhookHTTPMethod.post };
                break;
        }
        return {
            id: uuid.v4(),
            message: null,
            content: content,
        };
    };
    /**
     * Get SCUAlertActionTemplate based on SCUAlertAction.
     * @return SCUAlertActionTemplate based on SCUAlertAction instance.
     */
    SCUAlertAction.prototype.getTemplate = function () {
        var content;
        switch (this.content.type) {
            case 'email':
                content = { type: 'email', email: this.content.email };
                break;
            case 'phone':
                content = { type: 'phone', number: this.content.number };
                break;
            case 'sms':
                content = { type: 'sms', number: this.content.number };
                break;
            case 'webhook':
            default:
                content = { type: 'webhook', url: this.content.url, method: this.content.method };
                break;
        }
        return {
            id: this.id,
            message: this.message,
            content: content,
        };
    };
    /**
     * Create SCUAlertAction from template.
     * @param template
     * @return New SCUAlertAction based on template.
     */
    SCUAlertAction.fromTemplate = function (template) {
        var content;
        switch (template.content.type) {
            case 'email':
                content = template.content.email != null ? { type: 'email', email: template.content.email } : null;
                break;
            case 'phone':
                content = template.content.number != null ? { type: 'phone', number: template.content.number } : null;
                break;
            case 'sms':
                content = template.content.number != null ? { type: 'sms', number: template.content.number } : null;
                break;
            case 'webhook':
                content = template.content.url != null ? {
                    type: 'webhook',
                    url: template.content.url, method: template.content.method,
                } : null;
                break;
            default:
                content = null;
                break;
        }
        return content != null ? new SCUAlertAction(template.id, template.message, content) : null;
    };
    /**
     * Compare SCUAlertAction to another SCUAlertAction instance
     * to check if they are the same.
     * @param action SCUAlertAction to compare
     * @return True if same.
     */
    SCUAlertAction.prototype.isSame = function (action) {
        switch (action.content.type) {
            case 'email':
                return this.content.type == 'email' && action.content.email == this.content.email;
            case 'phone':
                return this.content.type == 'phone' && action.content.number == this.content.number;
            case 'sms':
                return this.content.type == 'sms' && action.content.number == this.content.number;
            case 'webhook':
                return this.content.type == 'webhook'
                    && action.content.url == this.content.url
                    && action.content.method == this.content.method;
            default:
                return false;
        }
    };
    /**
     * Get API param from SCUAlertAction.
     * @return Option representing API parameters.
     */
    SCUAlertAction.prototype.toAPIParam = function () {
        var content;
        if (this.content.type === 'webhook') {
            content = __assign(__assign({}, this.content), { method: bryxTypes_1.WebhookHTTPMethod[this.content.method] });
        }
        else {
            content = this.content;
        }
        return __assign(__assign({}, content), { message: this.message });
    };
    SCUAlertAction.actionTypes = ['phone', 'email', 'sms', 'webhook'];
    return SCUAlertAction;
}());
exports.SCUAlertAction = SCUAlertAction;
//# sourceMappingURL=scuAlert.js.map